export function getApiErrorMessage(data, fallback = 'Ошибка сервера') {
    if (!data) return fallback;

    if (typeof data === 'string') return data;

    for (const key of ['error', 'detail', 'message', 'text']) {
        if (typeof data[key] === 'string' && data[key].trim()) {
            return data[key];
        }
    }

    const fieldErrors = Object.entries(data).flatMap(([field, value]) => {
        const messages = Array.isArray(value) ? value : [value];
        return messages
            .filter(message => typeof message === 'string' && message.trim())
            .map(message => `${field}: ${message}`);
    });

    return fieldErrors.length ? fieldErrors.join('; ') : fallback;
}
